import { arrayMove } from 'react-sortable-hoc';
import type { Reducer, Effect, Subscription, Dispatch } from 'umi';

import type { TopNavbarClientProps } from '../components/TopNavbar/Client';
import AddComponentDefaultValue from '../componentList/AddComponent/defaultValues';


export type CustomizationState = {
  pageConfig?: TopNavbarClientProps,
  componentList: Record<string, any>[];
  currentIndex?: number; // undefined: 未选中、-1: 页面全局、>-1: 组件序号
}
export type CustomizationStateProps = {
  customization: CustomizationState;
  dispatch: Dispatch;
}
export const mapToCustomizationProps = ({ customization }: { customization: CustomizationState }) => {
  return {
    customization
  }
}
export type CustomizationType = {
  namespace: 'customization';
  state: CustomizationState,
  reducers: Record<string, Reducer>;
  effects: Record<string, Effect>;
  subscriptions: Record<string, Subscription>;
};


const Customization: CustomizationType = {
  namespace: 'customization',
  state: {
    pageConfig: undefined,
    componentList: [],
    currentIndex: undefined,
  },
  reducers: {
    setPageInfo(state, { payload: { pageConfig, componentList, currentIndex } }) {
      state.pageConfig = pageConfig;
      state.componentList = componentList || [];
      state.currentIndex = currentIndex;
    },
    clearPageInfo(state) {
      state.pageConfig = undefined;
      state.componentList = [];
      state.currentIndex = undefined;
    },
    setComponentList(state, { payload }) {
      state.componentList = payload;
    },
    setCurrentIndex(state, { payload }) {
      state.currentIndex = payload;
    },
    updatePageConfig(state, { payload }) {
      state.pageConfig = payload;
    },
  },
  effects: {
    // 添加、编辑页面，设置 pageInfo、currentIndex: -1
    *addPage({ payload }, { put }) {
      if (!payload?.componentList?.length) {
        payload.componentList = [{ ...AddComponentDefaultValue }];
      }
      yield put({ type: 'setPageInfo', payload });
      yield put({ type: 'setCurrentIndex', payload: -1 });
    },
    // 删除页面，清除 pageInfo、currentIndex
    *deletePage({}, { put }) {
      yield put({ type: 'setPageInfo', payload: {} });
      yield put({ type: 'setCurrentIndex' });
    },
    // 编辑页面全局配置
    *editPageConfig({}, { put }) {
      yield put({ type: 'setCurrentIndex', payload: -1 });
    },

    *addAddComponent({ payload: { index, data } }, { put, select }) {
      const componentList: Record<string, any>[] = yield select((state: any) => state.customization.componentList);
      const tempList = [...componentList];
      tempList.splice(index + 1, 0, data);
      yield put({ type: 'setComponentList', payload: tempList });
      yield put({ type: 'setCurrentIndex', payload: index + 1 });
    },
    // 模拟器中按钮添加新组件，使用新组件信息替换添加组件信息
    *replaceAddComponent({ payload: { index, data } }, { put, select }) {
      const componentList: Record<string, any>[] = yield select((state: any) => state.customization.componentList);
      const tempList = [...componentList];
      tempList[index] = data;
      yield put({ type: 'setComponentList', payload: tempList });
      yield put({ type: 'setCurrentIndex', payload: index });
    },
    // 排序组件
    *sortComponents({ payload: { oldIndex, newIndex } }, { put, select }) {
      const componentList: Record<string, any>[] = yield select((state: any) => state.customization.componentList);
      yield put({ type: 'setComponentList', payload: arrayMove([...componentList], oldIndex, newIndex) });
      yield put({ type: 'setCurrentIndex', payload: newIndex });
    },
    // 删除组件，如果最后一个组件被删除，则添加一个 AddComponent 到列表中
    *deleteComponent({ payload }, { put, select }) {
      const componentList: Record<string, any>[] = yield select((state: any) => state.customization.componentList);
      const newList = componentList.length === 1 ? [AddComponentDefaultValue] : componentList.filter((_, index) => index !== payload );
      yield put({ type: 'setComponentList', payload: newList });
      yield put({ type: 'setCurrentIndex' });
    },
  },
  subscriptions: {

  }
}

export default Customization;
